"use strict";
(globalThis["webpackChunktvg_shopify_theme"] = globalThis["webpackChunktvg_shopify_theme"] || []).push([[9268],{

/***/ 8536:
/***/ ((__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) => {

/* harmony import */ var _hotwired_stimulus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7809);
/* harmony import */ var swiper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6361);



class HowItWorksController extends _hotwired_stimulus__WEBPACK_IMPORTED_MODULE_0__.Controller {
  static targets = [
    'videoSwiper',
    'video',
    'slidePdpControls',
    'videoPlay',
    'nextButton',
    'prevButton'
    ]

  connect() {
    this.initSwiper()
  }

  initSwiper() {
    const slideshowContainer = this.videoSwiperTarget
    const slideCount = parseInt(slideshowContainer.dataset.itemCount || '0', 10)

    if (!slideshowContainer || slideCount < 1) {
      return;
    }

    this.swiper = new swiper__WEBPACK_IMPORTED_MODULE_1__["default"](slideshowContainer, {
      modules: [swiper__WEBPACK_IMPORTED_MODULE_1__.Navigation, swiper__WEBPACK_IMPORTED_MODULE_1__.Scrollbar],
      direction: 'horizontal',
      slidesPerView: 'auto',
      spaceBetween: 16,
      loop: false,
      scrollbar: {
        el: `.${'swiper-scrollbar'}`,
        draggable: true
      },
      navigation: {
        nextEl: this.nextButtonTarget,
        prevEl: this.prevButtonTarget,
      },
      init: false
    })

    this.swiper.init()
  }

  toggleVideo(evt) {
    evt.preventDefault()
    const videoElem = evt.currentTarget
    const videoID = videoElem.dataset.video
    const videoPlayElem = this.videoPlayTargets.find(videoPlayTarget => videoPlayTarget.dataset.video === videoID)

    if (videoElem instanceof HTMLVideoElement) {
      if (videoElem.paused) {
        this.pauseAllVideos()
        this.playVideo(videoElem, videoPlayElem)
      } else {
        this.pauseVideo(videoElem, videoPlayElem)
      }
    }
  }

  pauseAllVideos() {
    this.videoTargets.forEach(video => {
      const videoPlayElem = this.videoPlayTargets.find(videoPlayTarget => videoPlayTarget.dataset.video === video.dataset.video)
      this.pauseVideo(video, videoPlayElem)
    })
  }

  playVideo(videoElem, videoPlayElem) {
    videoPlayElem.style.display = 'none'
    videoElem.play()
    videoElem.controls = true
  }

  pauseVideo(videoElem, videoPlayElem) {
    videoPlayElem.style.display = 'block'
    videoElem.pause()
    videoElem.controls = false
  }

  onVideoEnded(evt) {
    const videoElem = evt.currentTarget
    const videoPlayElem = this.videoPlayTargets.find(videoPlayTarget => videoPlayTarget.dataset.video === videoElem.dataset.video)
    const originalPoster = videoElem.getAttribute('data-poster')

    videoPlayElem.style.display = 'block'
    videoElem.controls = false
    videoElem.poster = originalPoster
    videoElem.load()
  }
}

Stimulus.register("how-it-works", HowItWorksController)


/***/ })

},
/******/ __webpack_require__ => { // webpackRuntimeModules
/******/ var __webpack_exec__ = (moduleId) => (__webpack_require__(__webpack_require__.s = moduleId))
/******/ __webpack_require__.O(0, [2333], () => (__webpack_exec__(8536)));
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ }
]);